import React, { useContext, useEffect, useRef, useState } from 'react';
import { getCompanyReportInformation } from '../../../../apis/Report/Report';
import { CompanyContext, PRINT_WIDTH } from '../';
import { fontReport } from '../../../../apis/util';

export const CompanyReportInformation = () => {

  const [name, setName] = useState("");
  const [cvr, setCVR] = useState("");
  const [email, setEmail] = useState("");
  const date = new Date().toLocaleDateString();
  const [preparedBy, setPreparedBy] = useState("");
  const { companyName, address } = useContext(CompanyContext);

  useEffect(() => {
    getCompanyReportInformation({
      setName: setName,
      setCVR: setCVR,
      // setAddress:setAddress,
      setEmail: setEmail,
      // setDate:setDate,
      setPreparedBy: setPreparedBy,
    });

  }, []);
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="companyreportinformation" ref={ref}>
      <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px") }}>Company Report Information</h5>
      <div className="companyreportinformation__info">
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>Company Name:</h6>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>{companyName}</h6>
      </div>
      <div className="companyreportinformation__info">
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>CVR Number:</h6>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>{cvr}</h6>
      </div>
      <div className="companyreportinformation__info">
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>Address:</h6>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>{address}</h6>
      </div>
      <div className="companyreportinformation__info">
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>Contact Mail of responsible:</h6>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>{email}</h6>
      </div>
      <div className="companyreportinformation__info">
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>Date:</h6>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>{date}</h6>
      </div>
      <div className="companyreportinformation__info">
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>Prepared by:</h6>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,18/PRINT_WIDTH,"px") }}>{preparedBy}</h6>
      </div>
    </div>
  );
};
